import React from 'react';
interface MultiSelectChipsProps {
  options: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
  label?: string;
}
export function MultiSelectChips({
  options,
  selected,
  onChange,
  label
}: MultiSelectChipsProps) {
  const toggleOption = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter(item => item !== option));
    } else {
      onChange([...selected, option]);
    }
  };
  return <div className="w-full" data-id="element-1124">
      {label && <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1125">
          {label}
        </label>}
      <div className="flex flex-wrap gap-2" data-id="element-1126">
        {options.map(option => {
        const isSelected = selected.includes(option);
        return <button key={option} type="button" onClick={() => toggleOption(option)} className={`
                px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 border
                ${isSelected ? 'bg-indigo-600 text-white border-indigo-600 shadow-sm' : 'bg-white text-gray-700 border-gray-300 hover:border-indigo-300 hover:bg-gray-50'}
              `} data-id="element-1127">
              {option}
            </button>;
      })}
      </div>
    </div>;
}